/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { t } from 'i18next';
import PropTypes from 'prop-types';
import { LoadingGif, ContentContainer, LoaderWrapper } from './css';
import { H2, P } from '../../../theme/typographySitecore';

const Loader = (props) => {
  const { isLoading, title, subtitle } = props;

  const titleLabel = (title) || t('LoadingIndicatorHeader');
  const subtitleLabel = (subtitle) || t('LoadingIndicatorBody');

  const LoaderHeader = () => (
    <LoadingGif />
  );

  const LoaderBody = () => (
    <ContentContainer>
      <H2 field={titleLabel} />
      <P field={subtitleLabel} />
    </ContentContainer>
  );

  if (isLoading) {
    return (
      <LoaderWrapper>
        <LoaderHeader />
        <LoaderBody />
      </LoaderWrapper>
    );
  }

  return null;
};

Loader.propTypes = {
  isLoading: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default Loader;
